<template>
  <div class="DealList">
    <DealCard
      v-for="item in deals"
      :key="item.id"
      :deal="item"
    />
  </div>
</template>

<script>
import DealCard from '@/components/deal/Card.vue';

export default {
  name: 'DealList',
  components: {
    DealCard,
  },
  props: {
    deals: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.DealCard {
  margin-bottom: 55px;
}
</style>
